import React from "react";
import "react-activity/dist/library.css";
import { Root, Img } from "./style"
import logo from "../../assets/logo.png";
import ButtonLog from "../buttonCadastro";
import BarraProgresso4 from "../barraProgresso/dPageFourBar";
import { Link } from "react-router-dom";


const RootCadastro4: React.FC = () => {
    return ( 
    <>
        <Root>
            <div>
                <Link to="/">
                    <Img src={logo} alt="logo" />
                </Link>
            </div>
            <div>
                <ButtonLog />
            </div>
        </Root>
        <BarraProgresso4 />
    </>
    );
};

export default RootCadastro4;